import React from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useAuth } from "../contexts/AuthContextWithQuery";

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

export const DevToolsManager: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const [showDevtools, setShowDevtools] = React.useState(false);

  // Initialize devtools visibility based on user role
  React.useEffect(() => {
    if (isAuthenticated && user) {
      // Show devtools by default only for superusers
      setShowDevtools(user.is_superuser);
    } else {
      // Hide devtools when not authenticated
      setShowDevtools(false);
    }
  }, [isAuthenticated, user]);

  // Expose toggle function to window for manual control
  React.useEffect(() => {
    // @ts-ignore
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <>
      {/* Development DevTools - always available in dev mode */}
      <ReactQueryDevtools initialIsOpen={false} />
      
      {/* Production DevTools - conditionally rendered */}
      {showDevtools && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtoolsProduction initialIsOpen={false} />
        </React.Suspense>
      )}
    </>
  );
};
